import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'dashboard-v2-completed-trainings',
  templateUrl: './completed-trainings.component.html',
})
export class DashboardV2CompletedTrainingsComponent {
  @Input() trainings: any[] = [];
  @Input() ranges: string[] = [];
  @Input() activeRange = '';
  @Input() chartBars: any[] = [];
  @Input() chartBarGap = 58;
  @Input() loading = false;
  @Input() error = '';
  @Output() rangeChange = new EventEmitter<string>();
  @Output() studentClick = new EventEmitter<any>();
  @Output() tutorialClick = new EventEmitter<void>();
}
